import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";

const normalizeStroke = (stroke, fallback) => ({
  color: stroke?.color || fallback.color,
  dash: stroke?.dash || fallback.dash,
  width: stroke?.width ?? fallback.width,
  opacity: stroke?.opacity ?? fallback.opacity,
});

const FALLBACK_UP = { color: "#00DD00", dash: "Solid", width: 1, opacity: 1 };
const FALLBACK_DOWN = { color: "#FF0000", dash: "Solid", width: 1, opacity: 1 };

class AroonSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorAroonUp = this.yAccessorAroonUp.bind(this);
    this.yAccessorAroonDown = this.yAccessorAroonDown.bind(this);
  }

  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    if (!indicator || !indicator.renderKey) {
      return undefined;
    }

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    dataArr.forEach((item) => {
      const node = item && item[indicator.renderKey];
      if (!node || typeof node !== "object") return;

      const updateExtents = (value) => {
        if (!Number.isFinite(value)) return;
        if (value < min) min = value;
        if (value > max) max = value;
      };

      updateExtents(node.aroonUp);
      updateExtents(node.aroonDown);
    });

    // Default to 0-100 if no valid data
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      return [0, 100];
    }

    return [min, max];
  }

  yAccessorAroonUp(d) {
    const { yAccessor } = this.props;
    const aroonData = yAccessor(d);
    return aroonData && aroonData.aroonUp;
  }

  yAccessorAroonDown(d) {
    const { yAccessor } = this.props;
    const aroonData = yAccessor(d);
    return aroonData && aroonData.aroonDown;
  }

  render() {
    const { className, strokeAroonUp, strokeAroonDown } = this.props;

    const upStroke = normalizeStroke(strokeAroonUp, FALLBACK_UP);
    const downStroke = normalizeStroke(strokeAroonDown, FALLBACK_DOWN);

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorAroonUp}
          stroke={upStroke}
          connectNulls
          highlightOnHover={false}
        />
        <LineSeries
          yAccessor={this.yAccessorAroonDown}
          stroke={downStroke}
          connectNulls
          highlightOnHover={false}
        />
      </g>
    );
  }
}

AroonSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  strokeAroonUp: PropTypes.object,
  strokeAroonDown: PropTypes.object,
};

AroonSeries.defaultProps = {
  className: "react-stockcharts-aroon-series",
  strokeAroonUp: FALLBACK_UP,
  strokeAroonDown: FALLBACK_DOWN,
};

export default AroonSeries;
